
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { SnackBarService } from '../../../../cw-utils/snackbar.service';
import { TableTypeVersion } from '../../../models/backend-definitions.module';

@Injectable()
export class TableTypeVersionEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    tableTypeVersion: TableTypeVersion;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getTableTypeVersion()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getTableTypeVersion(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('tableTypeVersion/' + this.routeParams.id).subscribe((res: TableTypeVersion ) => {
                    this.tableTypeVersion = res;
                    this.onDataChanged.next(this.tableTypeVersion);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(tableTypeVersion): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('tableTypeVersion/', tableTypeVersion).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(tableTypeVersion): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('tableTypeVersion/', tableTypeVersion).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(tableTypeVersion): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('tableTypeVersion/' + tableTypeVersion.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }
}
